import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {slotStore} from '@gongxigames/framework/slotV2/globals';

export const specialInfoZonePositionLandscape = Store.signal('bottom');
export const specialInfoZonePositionPortrait = Store.signal('bottom');

const position = Store.computed(() => {
    return slotStore.stage_isLandscape.value ? specialInfoZonePositionLandscape.value : specialInfoZonePositionPortrait.value;
});

export const specialInfoZoneStore = Store.createStore({
    numberOfRows: Store.signal(0),

    // TODO: refactor... Other UIs may not have a black line,
    // there may be a different abstraction
    blackPanelHeight: Store.signal(44),

    position
});